/** @jsxImportSource @emotion/react */
import { ClickAwayListener } from '@mui/material';
import { ReactElement } from 'react';
import { DefaultTooltip } from './components';

type placements =
  | 'bottom-end'
  | 'bottom-start'
  | 'bottom'
  | 'left-end'
  | 'left-start'
  | 'left'
  | 'right-end'
  | 'right-start'
  | 'right'
  | 'top-end'
  | 'top-start'
  | 'top';

export interface Props {
  title: string;
  children: ReactElement;
  open?: boolean;
  placement?: placements;
  onClose?: () => void;
}

export const Tooltip = ({
  title,
  placement,
  children,
  open,
  onClose,
}: Props) => {
  const controlledTooltip = typeof open === 'boolean' && onClose;

  return controlledTooltip ? (
    <ClickAwayListener onClickAway={onClose}>
      <div>
        <DefaultTooltip
          title={title}
          placement={placement}
          onClose={onClose}
          open={open}
        >
          {children}
        </DefaultTooltip>
      </div>
    </ClickAwayListener>
  ) : (
    <DefaultTooltip title={title} placement={placement}>
      {children}
    </DefaultTooltip>
  );
};
